import React, { useState, useEffect } from "react";
import { CountdownCircleTimer } from "react-countdown-circle-timer";
import { Link, useNavigate, useLocation } from "react-router-dom";
import Footer from "../../components/Footer.jsx";
import { useTranslation } from "react-i18next";
import Loader from "../../components/Loader.jsx";
import axiosInstance from "../../utils/axiosInstance.js";
import { decryptFields } from "../../utils/kycStatus.js";
import { toast } from "react-toastify";
import CustomButton from "../../components/CustomButton.jsx";
const Swal = require("sweetalert2");

function SellSummary() {
  const navigate = useNavigate();
  const location = useLocation();

  const { t } = useTranslation();
  const { orderSummary, priceExpire } = t("goldOrderSummaryPage");

  const [kycDone, setKycDone] = useState(false);

  useEffect(() => {
    const userDetails = JSON.parse(localStorage.getItem("userDetails"));

    if (userDetails) {
      const decryptedData = decryptFields(userDetails, ["pan", "bank"]);
      if (decryptedData.pan === true && decryptedData.bank === true) {
        setKycDone(true);
      }
    }
  }, []);

  const isGold = location.pathname.includes("gold") ? "Gold" : "Silver";

  const data = location.state;

  const provider = location.state.key === "augmont" ? true : false;

  const {
    preTaxAmount: mmtcPreTaxAmount,
    quantity: mmtcQuantity,
    totalAmount: mmtcTotalAmount,
    metalRate: mmtcLiveRate,
    // taxAmount: mmtcTaxAmount,
    // transactionRefNo: mmtcTransactionRefNo,
  } = data?.data?.data?.[0] || {};

  const {
    totalQuantity: augQuantity,
    // goldPrice: augLiveGold,
    // silverPrice: augLiveSilver,
    totalAmount: augAmount,
    // gst: augGst,
    amountAfterTax: augAmountAfterTax,
    merchantTransactionId: augMerchantTransactionId,
    metalType,
    pricePerGram: augLivePrice,
  } = data?.data?.data?.[0] || {};

  const { message } = data?.data || "";

  const mClick = data.clickFirst;

  const [loading, setLoading] = useState(false);

  const callGetBuyAPI = async () => {
    setLoading(true);
    try {
      const url = `/augmont/sell-gold-silver`;
      const requestBody = {
        metalType: metalType,
        quantity: augQuantity,
      };

      if (mClick === "A") {
        requestBody["amount"] = augAmountAfterTax;
      } else if (mClick === "Q") {
        requestBody["quantity"] = augQuantity;
      } else {
        requestBody["amount"] = augAmountAfterTax;
      }

      const response = await axiosInstance.post(url, requestBody);
      setLoading(false);
      const transactionId =
        response?.data?.data[0]?.result?.data?.transactionId;

      Swal.fire({
        title: "Sold Successful",
        html: `
        Transaction Number: ${transactionId}<br/><br/>
        Amount: ₹${augAmountAfterTax}
      `,
        icon: "success",
        confirmButtonColor: "#4A2A7D",
        cancelButtonColor: "#d33",
        confirmButtonText: "Ok",
      }).then((d) => {
        navigate("/dashboard/history");
      });
    } catch (error) {
      setLoading(false);
      console.log("ERROR IN CATCH++++++++++++", error);
    } finally {
      setLoading(false);
    }
  };

  const handlePayment = () => {
    Swal.fire({
      title: "Are you sure?",
      text: "You won't be able to revert this!",
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#4A2A7D",
      cancelButtonColor: "#d33",
      confirmButtonText: "Proceed to sell !",
    })
      .then((d) => {
        if (d.isConfirmed === true) {
          callGetBuyAPI();
          // const payload = {
          //   metalType: mt,
          //   quantity: Goldweight,
          // };

          // dispatch(goldAndSilverSellSlice(payload));
        }
      })
      .catch((error) => {
        console.log("error", error);
      });
  };

  // MMTC API's=================

  const [loadingSell, setLoadingSell] = useState(false);

  const mmtcExecuteSell = async () => {
    const result = await Swal.fire({
      title: "Are you sure you want to sell?",
      icon: "warning",
      showCancelButton: true,
      confirmButtonText: "Yes, Sell",
      cancelButtonText: "No, Cancel",
      confirmButtonColor: "#3085d6",
      cancelButtonColor: "#d33",
    });

    if (result.isConfirmed) {
      try {
        setLoadingSell(true);
        const payload = {
          ...data?.data?.data?.[0],
        };

        const response = await axiosInstance.post(
          "/customTrade/executeSell",
          payload
        );

        if (!response.data.error) {
          Swal.fire({
            title: response.data.message || "Sell executed successfully!",
            icon: "success",
            confirmButtonColor: "#3085d6",
          });
          navigate("/dashboard/history");
          // navigate("/dashboard/goldSoldInvoice", {
          //   state: { buyData: response.data, provider: "mmtc" },
          // });
        } else {
          toast.error("Execute API ERROR TRUE");
        }
      } catch (error) {
        console.log(error);
      } finally {
        setLoadingSell(false);
      }
    }
  };

  return (
    <div style={{ height: "auto", width: "100%" }}>
      {/* <BackButton /> */}
      {loading || loadingSell ? (
        <div style={{ height: "90vh" }}>
          <Loader />
        </div>
      ) : (
        <div className="summary_container">
          <div style={{ textAlign: "center" }}>
            <h2>{orderSummary}</h2>
          </div>
          {/* DETAILS=======  */}
          {/* <div className="row">
            <table className="table table-borderless">
              <tbody>
                <tr>
                  <td></td>
                  <td
                    style={{ color: "black", fontSize: "20px" }}
                    className=" fs-5"
                  >
                    {isGold} Weight AUGMONT (gm)
                  </td>
                  <td></td>
                  <td></td>
                  <td></td>
                  <td
                    style={{ color: "black", fontSize: "20px" }}
                    className=" fs-5"
                  >
                    {provider ? augQuantity : mmtcQuantity}
                  </td>
                </tr>
                <tr>
                  <td></td>
                  <td
                    style={{ color: "black", fontSize: "20px" }}
                    className=" fs-5"
                  >
                    {isGold} Rate per gram (₹)
                  </td>
                  <td></td>
                  <td></td>
                  <td></td>
                  <td
                    style={{ color: "black", fontSize: "20px" }}
                    className=" fs-5"
                  >
                    {provider ? augLivePrice : mmtcLiveRate}
                  </td>
                </tr>
                <tr>
                  <td></td>
                  <td
                    style={{ color: "black", fontSize: "20px" }}
                    className=" fs-5"
                  >
                    {isGold} Value Of {provider ? augQuantity : mmtcQuantity}
                    /gm (&#8377;)
                  </td>
                  <td></td>
                  <td></td>
                  <td></td>
                  <td
                    style={{ color: "black", fontSize: "20px" }}
                    className=" fs-5"
                  >
                    {provider ? augAmount : mmtcPreTaxAmount}
                  </td>
                </tr>

                <tr>
                  <td></td>
                  <td className="fw-bold fs-5">Total Amount (&#8377;)</td>
                  <td></td>
                  <td></td>
                  <td></td>
                  <td className="fw-bold fs-5">
                    {provider ? augAmountAfterTax : mmtcTotalAmount}
                  </td>
                </tr>
                <tr>
                  <td></td>
                  <td></td>
                  <td></td>
                  <td></td>
                  <td></td>
                </tr>
              </tbody>
            </table>
          </div> */}

          <section
            style={{
              display: "flex",
              justifyContent: "space-around",
              gap: "1rem",
              // fontSize: "1.2rem",
            }}
          >
            <div>
              <div>{isGold} Weight (gm)</div>
              <div>{isGold} Rate per gram (₹)</div>
              <div>
                {isGold} Value Of {provider ? augQuantity : mmtcQuantity}
                /gm (&#8377;)
              </div>
              {/* <div>{gst} (&#8377;)</div> */}
              <strong>Total Amount (&#8377;)</strong>
            </div>
            <div>
              <div>{provider ? augQuantity : mmtcQuantity}</div>
              <div>{provider ? augLivePrice : mmtcLiveRate}</div>
              <div>{provider ? augAmount : mmtcPreTaxAmount}</div>
              {/* <div>{provider ? augGst : mmtcTaxAmount}</div> */}
              <strong>{provider ? augAmountAfterTax : mmtcTotalAmount}</strong>
            </div>
          </section>

          <div
            style={{
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
              textAlign: "center",
              gap: "5px",
              margin: "2rem auto",
            }}
          >
            <span className=" mt-2 mr-3" style={{ color: "black" }}>
              {priceExpire}
            </span>{" "}
            <CountdownCircleTimer
              isPlaying
              size={60}
              strokeWidth={10}
              duration={180} // 3 minutes in seconds
              colors={["#111111", "#111111", "#111111", "#111111"]}
              colorsTime={[180, 120, 60, 0]}
              onComplete={() => {
                navigate(-1); // Redirect to the previous history page
                return { shouldRepeat: false }; // Ensure the timer doesn't repeat
              }}
            >
              {({ remainingTime }) => {
                const minutes = Math.floor(remainingTime / 60);
                const seconds = remainingTime % 60;
                const formattedTime = `${minutes}:${seconds
                  .toString()
                  .padStart(2, "0")}`;
                return (
                  <div style={{ fontSize: "18px", fontWeight: "bold" }}>
                    {formattedTime}
                  </div>
                );
              }}
            </CountdownCircleTimer>
          </div>

          {message !== "success" && (
            <div
              style={{
                color: "red",
                // backgroundColor: "#dadcff",
                borderRadius: "10px",
                fontSize: "0.8rem",
                padding: "0.5rem",
                textAlign: "center",
              }}
            >
              <i>
                <strong> Note: </strong>
                {message}
              </i>
            </div>
          )}
          <Footer metalType={isGold} />
          <div
            style={{
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
              margin: "2rem auto",
            }}
          >
            {kycDone ? (
              <CustomButton
                label="SELL"
                onClick={provider ? handlePayment : mmtcExecuteSell}
              />
            ) : (
              <Link to="/dashboard/profile/profileSetting">
                <CustomButton label="Complete KYC" />
              </Link>
            )}
          </div>
        </div>
      )}
    </div>
  );
}

export default SellSummary;
